module.exports = __webpack_public_path__ + "img/6.dbb8bfc8.jpg";